import { render, staticRenderFns } from "./huoshanSpeakerList.vue?vue&type=template&id=0c878e75"
import script from "./huoshanSpeakerList.vue?vue&type=script&lang=js"
export * from "./huoshanSpeakerList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports